import { render } from "./GibergTrilevis.vue?vue&type=template&id=72f0fa06&scoped=true"
import script from "./GibergTrilevis.vue?vue&type=script&lang=js"
export * from "./GibergTrilevis.vue?vue&type=script&lang=js"

import "./GibergTrilevis.vue?vue&type=style&index=0&id=72f0fa06&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f0fa06"]])

export default __exports__